module.exports = __webpack_public_path__ + "img/custom-item2-6.3d0b5e8.png";